export type NetlifyFormFields = Record<string, string | undefined>;

export class NetlifyFormSubmissionError extends Error {
  readonly status: number;

  constructor(status: number) {
    super("Netlify heeft het formulier niet geaccepteerd.");
    this.name = "NetlifyFormSubmissionError";
    this.status = status;
  }
}

export function encodeNetlifyForm(fields: NetlifyFormFields): string {
  const body = new URLSearchParams();

  for (const [name, value] of Object.entries(fields)) {
    if (value !== undefined) {
      body.append(name, value);
    }
  }

  return body.toString();
}

export async function submitNetlifyForm(
  fields: NetlifyFormFields,
  fetcher: typeof fetch = fetch,
): Promise<void> {
  const response = await fetcher("/", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: encodeNetlifyForm(fields),
  });

  if (!response.ok) {
    throw new NetlifyFormSubmissionError(response.status);
  }
}
